export default __webpack_public_path__ + "static/media/mobile.64485f58.png";